import MainLayout from "@/components/layout/admin/MainLayout.vue";
import Select2Multiple from 'v-select2-multiple-component';
import axios from "axios";
import CONFIG from "@/assets/js/config.js";
import {
  required
} from "vuelidate/lib/validators";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import store from '@/store';

export default {
  name: "CampusGradeEdit",
  components: {
    MainLayout,
    Select2Multiple,
    Loading
  },

  data() {
    return {
      isLoading: false,
      periodArr: [],
      gradeArr: [],
      gradingSettingArr: [],
      campusGradeData: {},
      submitted: false,
      disabled: false,
      campus_name: store.state.user.campus_master.campus_name,
      noDataMsg: CONFIG.NO_DATA_EXIST,
    };
  },

  validations: {
    campusGradeData: {
      acd_year_id: {
        required
      },
      grade_id: {
        required
      }
    }
  },

  methods: {
    getAcademicYear() {
      axios.get('period/periodList')
        .then(res => {
          this.periodArr = res.data.data;
        }).catch((error) => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
        });
    },

    getGrade() {
      axios.get("grade/gradeList")
        .then(res => {
          this.gradeArr = res.data.data;
        }).catch((error) => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
        });
    },

    getGradingSettings() {
      return axios.get("gradingSetting/options", {
        params: {
          campus_id: store.state.user.campus_id,
        },
      })
        .then(res => {
          this.gradingSettingArr = res.data.data || [];
        }).catch((error) => {
          if (error.response && error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
        });
    },

    applyDefaultGradingSetting() {
      if (this.campusGradeData.grading_setting_id != null) {
        return;
      }

      const defaultSetting = this.gradingSettingArr.find(setting => setting.is_default);
      if (defaultSetting) {
        this.campusGradeData.grading_setting_id = defaultSetting.id;
      }
    },

    getDetail() {
      axios.get(`campusGrade/detail/${this.$route.params.id}`)
        .then(res => {
          if (res.data) {
            this.campusGradeData = res.data;
            if (this.campusGradeData.grading_setting_id === undefined) {
              this.campusGradeData.grading_setting_id = null;
            }
            this.applyDefaultGradingSetting();
          }
          this.isLoading = false;
        })
        .catch(error => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        })
    },

    update() {
      this.submitted = true;
      this.disabled = true;
      if (this.$v.$invalid) {
        this.disabled = false;
        return;
      }

      this.campusGradeData.login_id = this.$store.state.user.id;
      const payload = {
        ...this.campusGradeData,
        grading_setting_id: this.campusGradeData.grading_setting_id || null,
      };
      axios.post(`campusGrade/update/${this.$route.params.id}` , payload)
        .then(res => {
          if (res.data.success == true) {
            this.$notification.success("Campus Grade Updated Successfully", {
              timer: 3,
              position: "bottomCenter"
            });
            this.$router.push({
              name: "campusGradeList"
            });
          } else {
            this.disabled = false;
            this.$notification.error(res.data.message, {
              timer: 3,
              position: "bottomCenter",
            });
          }
        }).catch(error => {
          this.disabled = false;
          this.isLoading = false;
          if (error.response) {
            if (error.response.status == 401) {
              this.$store.commit('logout');
              window.location.replace('login');
            } else if (error.response.status == 422) {
              const msg = error.response.data.message
                || (error.response.data.errors && Object.values(error.response.data.errors).flat().join('\n'))
                || 'Validation failed.';
              this.$notification.error(msg, {
                timer: 3,
                position: "bottomCenter",
              });
            }
          }
          this.isLoading = false;
        })
    }
  },

  mounted() {
    this.isLoading = true;
    this.getAcademicYear();
    this.getGrade();
    this.getGradingSettings().finally(() => {
      this.getDetail();
    });
  },
};
